import { CUSTOMER_JOURNEY_SERVICES_SUCCESS } from './../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_SERVICES_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyServicesSuccess.js